import type { RequiredGeneric } from '@pba/utils';
import { Col, Form, InputNumber, Row, Switch, Text } from 'ui';

export type CustomAmountFormValues = CustomAmount | NoCustomAmount;

type CustomAmount = {
  customAmount: number;
  showCustomAmount: true;
};

type NoCustomAmount = {
  showCustomAmount: false;
};

const CustomAmountFormContent = <T extends CustomAmountFormValues = never>(_: RequiredGeneric<T>) => (
  <>
    <Form.Item<CustomAmountFormValues>>
      <Row gutter="xs">
        <Col>
          <Form.Item<CustomAmountFormValues> name="showCustomAmount" noStyle valuePropName="checked">
            <Switch size="small" />
          </Form.Item>
        </Col>
        <Col>
          <Text size="small">Set custom amount</Text>
        </Col>
      </Row>
    </Form.Item>

    <Form.Item<CustomAmountFormValues> dependencies={['showCustomAmount']} noStyle>
      {({ getFieldValue }) =>
        getFieldValue('showCustomAmount') === true ? (
          <Col span={24}>
            <Form.Item<CustomAmountFormValues>
              label="Custom amount"
              name="customAmount"
              rules={[{ min: 1, required: true, type: 'number' }]}
            >
              <InputNumber fullWidth prefix="$" useFormatter />
            </Form.Item>
          </Col>
        ) : null
      }
    </Form.Item>
  </>
);

export default CustomAmountFormContent;
